import Immutable from 'immutable';

const LOAD = 'plugin/LOAD';
const LOAD_SUCCESS = 'plugin/LOAD_SUCCESS';
const ERROR = 'plugin/ERROR';

const LIST_ALL_PLUGINS_BY_UUID = 'plugin/LIST_ALL_PLUGINS_BY_UUID';
const LIST_PLUGINS = 'plugin/LIST_PLUGINS';
const UPDATE_PLUGIN_LIST = 'plugin/UPDATE_PLUGIN_LIST';
const SAVE_PLUGIN = 'plugin/SAVE_PLUGIN';

const initialState = Immutable.fromJS({
  error: null,
  loading: false,
  allPluginList: [],
  pluginList: [],
  message: null,
  uuid: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true);

    case LOAD_SUCCESS:
      return state
        .set('loading', false);

    case LIST_ALL_PLUGINS_BY_UUID:
      return state
        .set('allPluginList', action.result);

    case LIST_PLUGINS:
      return state
        .set('loading', false)
        .set('pluginList', action.result);

    case UPDATE_PLUGIN_LIST:
      return state
        .set('pluginList', action.result);

    case SAVE_PLUGIN:
      return state
        .set('message', action.message)
        .set('uuid', action.uuid)
        .set('loading', false);

    case ERROR:
      return state
        .set('error', action.error);

    default:
      return state;
  }
}

export const getAllPluginsByUuId = (uuid) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const result = await api.get(`/plugin/${uuid}`);
    dispatch({ type: LIST_ALL_PLUGINS_BY_UUID, result });
    dispatch({ type: LOAD_SUCCESS });
  } catch (error) {
    dispatch({ type: ERROR, error });
  }
};

export const getPluginsByUserId = (userId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const result = await api.get(`/plugin/byUser/${userId}`);
    dispatch({ type: LIST_PLUGINS, result });
    return result;
  } catch (error) {
    dispatch({ type: ERROR, error });
  }
};

export const updatePluginList = (newPluginObj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  dispatch({
    type: UPDATE_PLUGIN_LIST,
    result: newPluginObj
  });
  dispatch({ type: LOAD_SUCCESS });
};

export const savePlugins = (id, data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  const msg = (id) ? 'Updated' : 'Added';

  let uuid = data.uuid;
  delete data.uuid;
  delete data.userId;
  try {
    let addResult = null;
    if (id) {
      await api.put(`/plugin/${id}`, { data });
    } else {
      addResult = await api.post('/plugin', { data });
      uuid = addResult.uuid;
    }
    dispatch({ 
      type: SAVE_PLUGIN, 
      message: 'Filter Successfully ' + msg, 
      uuid 
    });
    return id ? data : addResult;
  } catch (error) {
    dispatch({ type: ERROR, error });
  }
};

export const deletePlugin = (pluginId) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const result = await api.del(`/plugin/${pluginId}`);
    if(result && result.message) {
      dispatch({ type: ERROR, error: result.message });
      return;
    }
    const userPlugins = getState().get('plugins').get('pluginList');
    dispatch({ type: LIST_PLUGINS, result: Object.assign([], userPlugins.filter(p => p.id !== pluginId)) });
  } catch (error) {
    dispatch({ type: ERROR, error });
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/plugins.js